import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { TrackStepDirective } from '@analytics/events';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import { ReactiveFormsAbstractionsModule } from '@innogy/feh/rfa';
import type { FormGroup } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  HomeBatteryWizardRendering,
  type HomeBatteryWizardFormControls,
} from '@feh/homebattery-models';
import { CrntButton, CrntIcon } from '@essent/current-web-angular';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import type { FehAddressCheckService } from '@innogy/feh/services';

@Component({
  selector: 'wl-homebattery-ui',
  standalone: true,
  imports: [
    CommonModule,
    CommonUiUtilityComponentsModule,
    TrackStepDirective,
    ReactiveFormsAbstractionsModule,
    FontAwesomeModule,
    ScFieldValuePipe,
    CrntButton,
    CrntIcon,
    CommonUiFormsModule,
  ],
  templateUrl: './homebattery-wizard-ui.component.html',
})
export class HomebatteryWizardUiComponent {
  public readonly rendering = input.required<HomeBatteryWizardRendering>();
  public readonly trackToolConfig = input.required<any>();
  public readonly homeBatteryForm =
    input.required<FormGroup<HomeBatteryWizardFormControls>>();
  public readonly addressCheckService =
    input.required<FehAddressCheckService>();

  public readonly submitForm = output<void>();
  public readonly openModal = output<void>();

  submit() {
    this.submitForm.emit();
  }

  openEstimationModal() {
    this.openModal.emit();
  }
}
